<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    :return-value.sync="lazyValue"
    offset-y nudge-top="26"
    min-width="290px"
    class="pa-3"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field full-width
                    color="#008EF0"
                    v-model="dateValue"
                    :readonly="disabled"
                    v-bind="$attrs"
                    @click="disabled ? menu = true : menu = false"
      >
          <template v-slot:append>
              <v-icon @click="$attrs.readonly ? menu = false : menu = true" class="mt-1" color="#008EF0" small>
                  fas fa-calendar
              </v-icon>
          </template>
      </v-text-field>
    </template>
    <v-row class="pa-2 rounded-t white">
    <v-date-picker v-model="lazyValue" no-title scrollable @change="onDateChange" />
    <v-time-picker v-if="hora !== undefined" ref="timepicker" format="24hr"  no-title scrollable v-model="horaValue"
                   @change="onTimeChange" />

    </v-row>
    <v-row class="pa-2 d-flex justify-space-between white">
      <v-btn text color="primary" @click="menu = false">
          Cancel
      </v-btn>
      <v-btn text color="primary" @click="onSaveClick">
        OK
      </v-btn>
    </v-row>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MenuDatepicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: null,
    hora: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      lazyValue: this.value
    }
  },
    watch: {
      value(newValue){
          this.lazyValue = newValue;
      }
    },
  methods: {
    onSaveClick() {
      let dataFormatada = this.formatDate(this.dateValue)
      this.$emit('change', dataFormatada)
      this.$refs.menu.save(this.lazyValue)
    },
    onDateChange() {
      let dataFormatada = this.formatDate(this.dateValue)
      this.$emit('change', dataFormatada)

      if (this.hora !== undefined) return
      this.$refs.menu.save(this.lazyValue)
    },
    onTimeChange() {
      this.$refs.timepicker.selectingHour = true
      this.$refs.menu.save(this.lazyValue)
    },
    formatDate(v){
      const parsedDate = moment(v, 'DD/MM/YYYY')
      if (!parsedDate.isValid() || !v) return ''
      return moment(this.lazyValue).format('YYYY-MM-DD')
    }
  },
  computed: {
    dateValue: {
      get() {
        const parsedDate = moment(this.lazyValue)
        if (!parsedDate.isValid() || !this.lazyValue) return ''
        const horaFormatada = moment(this.lazyValue).format('DD/MM/YYYY')
        return this.hora === '' || !this.hora ? horaFormatada : horaFormatada + ' - ' + this.horaValue
      },
      set(value) {
        this.lazyValue = value
        this.$emit('change', this.formatDate(this.dateValue))
        this.$refs.menu.save(this.lazyValue)
      }
    },
    horaValue: {
      get() {
        return this.hora
      },
      set(value) {
        this.$emit('update:hora', value)
      }
    },
  }
}
</script>

<style scoped>
.clickable:hover {
  cursor: pointer;
  user-select: none;
}
</style>
